<template>
    <div>
      <div class="login-box">
      <div class="login-logo "><h2 class="text-white">Django-Advanced-Chat</h2></div>
      <div class="login-box-body">
          <template v-if="!emailCompleted">
            <p class="login-box-msg">Введите e-mail с которого вы регистрировали аккаунт</p>

            <form method="post"  @submit.prevent="submit" class="form-element">
              <div class="form-group has-feedback">
                <input type="email" class="form-control" placeholder="Email" v-model="inputs.email" required>
                <span class="ion ion-email form-control-feedback"></span>
                <span  class="error-field text-danger" v-show="emailError" >В процессе восстановления пароля произошла ошибка</span>
              </div>

              <div class="row">
                <div class="col-12 text-center">
                  <button type="submit" class="btn btn-info btn-block btn-flat margin-top-10" @click="sendPasswordResetEmail(inputs)">Отправить письмо для восстановления</button>
                </div>
                <!-- /.col -->
              </div>
            </form>
      </template>
      <template v-else>
        <div>Проверьте вашу входящую почту, там должна быть ссылка на восстановление пароля, если e-mail не прийдёт в течении нескольких минут, проверьте папку спам.</div>
      </template>
        <div class="margin-top-30 text-center">
          <p>Вспомнили пароль? <a href="/login" class="text-info m-l-5">Войти</a></p>
        </div>

      </div>
      <!-- /.login-box-body -->
    </div>
      <!-- /.login-box -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      inputs: { email: '' },
      password_reset_form: true
    };
  },
  computed: mapState('password', [
    'emailCompleted',
    'emailError',
    'emailLoading',
  ]),
  methods: {
    ...mapActions('password', [
      'sendPasswordResetEmail',
      'clearEmailStatus',
    ]),
    goToIndex: function(){
      this.$router.push('/')
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearEmailStatus();
    next();
  },
};
</script>

<style>
form input {
  display: block
}

.error {
  color: crimson;
  font-size: 12px;
}
</style>
